import { render, staticRenderFns } from "./CodeColumn.vue?vue&type=template&id=65d0be59&scoped=true&"
import script from "./CodeColumn.vue?vue&type=script&lang=js&"
export * from "./CodeColumn.vue?vue&type=script&lang=js&"
import style0 from "./CodeColumn.vue?vue&type=style&index=0&id=65d0be59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0be59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d0be59')) {
      api.createRecord('65d0be59', component.options)
    } else {
      api.reload('65d0be59', component.options)
    }
    module.hot.accept("./CodeColumn.vue?vue&type=template&id=65d0be59&scoped=true&", function () {
      api.rerender('65d0be59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/CodeColumn.vue"
export default component.exports